import { EvergreenNoticePeriod, OrderAttributes } from 'api'
import { isNil } from 'lodash'

export enum SpreadsheetSettlementVenue {
  Bilateral = 'Bilateral',
  Direct = 'Direct',
  Sponsored = 'Sponsored'
}

export const MAX_CREATE_ORDER_SPREADSHEET_CONTENT_LENGTH = 50000

export enum CollectionTypeMappingEnum {
  ALL_OR_NOTHING = 'ALL_OR_NOTHING',
  ONE_CANCELS_OTHERS = 'ONE_CANCELS_OTHERS',
  SEND_INDIVIDUALLY = 'SEND_INDIVIDUALLY',
  ALL_OR_NOTHING_X = 'ALL_OR_NOTHING_X'
}

export const parseUserEnteredEvergreenNoticePeriod = (userEvergreenNoticePeriod: string): EvergreenNoticePeriod | null => {
  switch (userEvergreenNoticePeriod) {
    case '30':
      return EvergreenNoticePeriod.THIRTY
    case '60':
      return EvergreenNoticePeriod.SIXTY
    case '90':
      return EvergreenNoticePeriod.NINETY
    default:
      return null
  }
}

export const sanitizeParsedItems = (parsedItems: OrderAttributes[]) => {
  return parsedItems.map((order: OrderAttributes, idx: number) => {
    if (order.collectionId !== null) {
      return { ...order, collectionName: null, collectionType: null }
    }

    if (isNil(order.collectionId) && order.collectionName) {
      const sanitizedItems = parsedItems.slice(0, idx)

      const foundCollectionName = sanitizedItems.find(
        (o: OrderAttributes) => o.collectionName?.toLowerCase() === order.collectionName?.toLowerCase()
      )

      if (foundCollectionName) {
        return { ...order, collectionName: foundCollectionName?.collectionName }
      }
    }

    return order
  })
}
